import { DataBean } from "../DataBean";

export class FixedAssetItemsWithDefeatDates extends DataBean {


    public async getFixedAssetItemsWithDefeatDates(defeatDays:any,initDate:any,fixedAssetID:any,regex:any,idAccount:any,idStore:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetItemsWithDefeatDates_Number_java.util.Date_Number_String_Number_Number_java.util.List_Number_Number", [defeatDays,initDate,fixedAssetID,regex,idAccount,idStore,state,page,recordsPerPage]);
    }

 
}